var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZinizIconEps(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 501,
    height: 572,
    viewBox: "415 380 501 572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 4778.04 8043.28)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 4778.04 8043.28)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 4466.95 8043.28)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 5141.06 8043.28)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 4466.95 8043.28)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 5141.06 8043.28)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 4802.16 8042.32)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 3908.64 8042.32)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6213.55 -6213.55 0 5989.6 8042.32)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -5606.62 -5606.62 0 6367.98 7935.95)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -5171.36 -5171.36 0 6365.58 7779.52)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6409.73 -6409.73 0 6363.58 8183.91)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -6409.73 -6409.73 0 6363.57 8183.91)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ba2e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#494eaa"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5647.44 6042.3c-35.76-357.3-298.62-656.13-781.15-676.59-482.76-20.46-865.69 232.27-957.65 676.59 0 0 .22 0 .45-.23 95.33-137.16 286.46-230.7 506.82-230.7 68.36 0 136.03 11.47 201.47 31.03 59.36 17.99 110.17 67.91 174.93 53.07 28.79-6.52 55.09-20.91 82.08-33.06 84.32-37.77 174.48-51.04 265.77-51.04 220.59 0 411.71 93.54 507.05 230.7z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5647.44 6447.26c-3.38 1.57-6.98 3.15-11.03 4.95-98.26 129.29-283.53 216.53-496.25 216.53-89.27 0-178.76-16.64-262.18-49.92-30.36-11.91-59.8-36.87-92.86-40.25-5.17 0-10.12 0-15.07.23-25.85 3.37-46.1 21.58-70.15 32.83-28.56 13.26-59.14 23.16-89.04 31.25-63.41 17.54-129.3 25.86-194.95 25.86-213.61 0-399.57-87.92-497.61-218.33-6.29-2.03-9.66-3.15-9.66-3.15 91.96 444.31 474.89 697.05 957.65 676.59 482.53-20.47 745.39-319.07 781.15-676.59"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4466.95 6417.8c81.84 0 148.4-72.62 148.4-161.89s-66.56-161.9-148.4-161.9c-82.08 0-148.4 72.63-148.4 161.9s66.32 161.89 148.4 161.89"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5289.47 6255.91c0-89.27-66.56-161.9-148.41-161.9-82.07 0-148.4 72.63-148.4 161.9s66.33 161.89 148.4 161.89c81.85 0 148.41-72.62 148.41-161.89"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4615.35 6255.91c0-89.27-66.56-161.9-148.4-161.9-82.08 0-148.4 72.63-148.4 161.9s66.32 161.89 148.4 161.89c81.84 0 148.4-72.62 148.4-161.89"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5289.47 6255.91c0-89.27-66.56-161.9-148.41-161.9-82.07 0-148.4 72.63-148.4 161.9s66.33 161.89 148.4 161.89c81.85 0 148.41-72.62 148.41-161.89"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6339.93 3499.5H4669.2c10.04 0 40.33 39.6 47 46.18 46.2 45.53 92.21 91.26 138.08 137.11 138.23 138.16 274.74 277.96 410.62 418.41 7.26 7.51 14.61 15.12 19.68 24.25 20.4 36.69 1.97 102.31-.81 143.2-14.8 217.66-58.78 443.08-169.97 633.62-92.55 158.59-284.19 309.57-468.53 335.39-287.52 40.29-876.49 10.84-1166.14 10.84-368.22 0-333.14-504.1-333.14-504.1H4831.4s-490.96-565.46-539.17-644.36c-48.22-78.91-105.21-284.93-65.76-556.7 39.46-552.32 583.01-668.34 583.01-668.34h1377.03c65.75 0 232.33 120.4 267.39 304.51 35.07 184.11-113.97 319.99-113.97 319.99"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3989.65 3834.71s-420.81-394.51-473.4-493.14c-52.61-98.62-65.75-263 72.31-381.36 138.09-118.35 749.59-78.9 749.59-78.9s-429.51 162.18-348.5 953.4"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6792.29 5557.35c-70.16-144.13-346.27-210.24-346.27-210.24s-94.9-321.54-313.45-490.41c-156.73-115.57-263.75-140.31-263.75-140.31h-482.77c-51.04 180.11-99.83 304.01-225.64 428.8h436.33s321.54 24.73 346.27 346.27c-37.09 111.31-119.61 321.55 41.15 519.42 41.15-160.77 16.42-325.59 144.36-424.53 127.72-98.93 432.84-66.1 503 49.47 69.93 78.25 74.2 321.54 74.2 321.54l65.88-8.32s90.62-247.34 20.69-391.69"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6741.46 6314.46c-17.17-21.34-34.1-42.91-50.81-64.71-53.57-44.77-116.43-78.17-185.32-96.96 9.51 164.46 50.33 321.49 118.06 472.49 3.47 7.65 10.44 14.61 17.17 19.95 12.75 10.2 19.01 23.66 13.45 38.27-5.33 13.92-15.77 20.64-31.09 21.57-28.75 1.4-51.02-11.36-70.97-29.69-9.51-8.81-17.39-19.25-26.9-28.06-16.94-15.54-35.5-15.31-51.97.23-8.35 7.65-15.76 16.47-23.66 24.35-44.76 45-104.6 45.23-149.6.7-8.12-7.89-15.09-16.93-23.43-24.82-17.16-16.24-36.19-16-53.12.23-10.9 10.44-20.88 22.04-32.01 32.24-17.86 16.01-38.97 24.59-63.32 24.59-28.53 0-42.45-22.03-31.32-48.25 22.04-52.65 45.24-104.84 64.49-158.65 31.08-87.68 53.11-178.38 60.76-271.39 1.86-23.43 3.25-46.62 4.42-70.05-79.8 24.59-151.01 68.66-208.07 126.88-16.7 21.11-33.17 42.45-48.71 64.25-53.58 76.31-81.65 161.21-87.45 254.69-7.65 128.96 28.31 243.09 109.49 342.36 78.17 95.33 178.84 153.55 301.3 173.97 254.93 42.68 507.75-134.07 553.68-397.57 26.45-150.08-9.98-286.47-105.07-406.62"
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6530.38 6573.32c-3.48-10.2-6.26-19.02-9.28-27.83-32.24-90.23-55.44-182.78-69.13-277.65-6.03-42.68-9.97-85.59-11.82-128.5-22.04-3.02-44.54-4.64-67.51-4.64-26.67 0-53.11 2.09-78.62 6.26-4.64 137.32-32.94 270.23-78.64 399.66-4.18 12.52-8.58 24.82-14.61 41.75 36.42-14.38 68.42-16.24 97.88 2.09 15.78 9.74 29 24.12 42.22 37.34 25.28 25.28 44.07 25.75 67.96-1.16 22.27-25.28 46.39-47.09 82.11-48.94 12.3-.46 24.59.93 39.44 1.62"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6363.13 5867.46c-62.08 0-124.16.39-186.23-.28-14.8-.15-20.58 4.28-19.1 19.36 1.15 11.76 1.43 23.87-.03 35.57-2.17 17.49 5.81 20.77 21.24 20.41 37.22-.87 74.48-.27 111.73-.28 86.37-.03 172.74-.44 259.1.26 15.78.13 21.12-4.6 19.68-20.08-1.19-12.85-1.04-25.95-.03-38.83 1.04-13.31-4.57-16.32-16.89-16.22-63.16.5-126.32.23-189.47.23z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6159.13 6007.18v71.14h408.88v-71.14z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5647.44 6042.3c-35.76-357.3-298.62-656.13-781.15-676.59-482.76-20.46-865.69 232.27-957.65 676.59 0 0 .22 0 .45-.23 95.33-137.16 286.46-230.7 506.82-230.7 68.36 0 136.03 11.47 201.47 31.03 59.36 17.99 110.17 67.91 174.93 53.07 28.79-6.52 55.09-20.91 82.08-33.06 84.32-37.77 174.48-51.04 265.77-51.04 220.59 0 411.71 93.54 507.05 230.7z",
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5647.44 6447.26c-3.38 1.57-6.98 3.15-11.03 4.95-98.26 129.29-283.53 216.53-496.25 216.53-89.27 0-178.76-16.64-262.18-49.92-30.36-11.91-59.8-36.87-92.86-40.25-5.17 0-10.12 0-15.07.23-25.85 3.37-46.1 21.58-70.15 32.83-28.56 13.26-59.14 23.16-89.04 31.25-63.41 17.54-129.3 25.86-194.95 25.86-213.61 0-399.57-87.92-497.61-218.33-6.29-2.03-9.66-3.15-9.66-3.15 91.96 444.31 474.89 697.05 957.65 676.59 482.53-20.47 745.39-319.07 781.15-676.59",
    style: {
      fill: "url(#d)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4466.95 6417.8c81.84 0 148.4-72.62 148.4-161.89s-66.56-161.9-148.4-161.9c-82.08 0-148.4 72.63-148.4 161.9s66.32 161.89 148.4 161.89",
    style: {
      fill: "url(#f)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5289.47 6255.91c0-89.27-66.56-161.9-148.41-161.9-82.07 0-148.4 72.63-148.4 161.9s66.33 161.89 148.4 161.89c81.85 0 148.41-72.62 148.41-161.89",
    style: {
      fill: "url(#h)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4615.35 6255.91c0-89.27-66.56-161.9-148.4-161.9-82.08 0-148.4 72.63-148.4 161.9s66.32 161.89 148.4 161.89c81.84 0 148.4-72.62 148.4-161.89",
    style: {
      fill: "url(#j)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5289.47 6255.91c0-89.27-66.56-161.9-148.41-161.9-82.07 0-148.4 72.63-148.4 161.9s66.33 161.89 148.4 161.89c81.85 0 148.41-72.62 148.41-161.89",
    style: {
      fill: "url(#l)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6339.93 3499.5H4669.2c10.04 0 40.33 39.6 47 46.18 46.2 45.53 92.21 91.26 138.08 137.11 138.23 138.16 274.74 277.96 410.62 418.41 7.26 7.51 14.61 15.12 19.68 24.25 20.4 36.69 1.97 102.31-.81 143.2-14.8 217.66-58.78 443.08-169.97 633.62-92.55 158.59-284.19 309.57-468.53 335.39-287.52 40.29-876.49 10.84-1166.14 10.84-368.22 0-333.14-504.1-333.14-504.1H4831.4s-490.96-565.46-539.17-644.36c-48.22-78.91-105.21-284.93-65.76-556.7 39.46-552.32 583.01-668.34 583.01-668.34h1377.03c65.75 0 232.33 120.4 267.39 304.51 35.07 184.11-113.97 319.99-113.97 319.99",
    style: {
      fill: "url(#n)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3989.65 3834.71s-420.81-394.51-473.4-493.14c-52.61-98.62-65.75-263 72.31-381.36 138.09-118.35 749.59-78.9 749.59-78.9s-429.51 162.18-348.5 953.4",
    style: {
      fill: "url(#p)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6792.29 5557.35c-70.16-144.13-346.27-210.24-346.27-210.24s-94.9-321.54-313.45-490.41c-156.73-115.57-263.75-140.31-263.75-140.31h-482.77c-51.04 180.11-99.83 304.01-225.64 428.8h436.33s321.54 24.73 346.27 346.27c-37.09 111.31-119.61 321.55 41.15 519.42 41.15-160.77 16.42-325.59 144.36-424.53 127.72-98.93 432.84-66.1 503 49.47 69.93 78.25 74.2 321.54 74.2 321.54l65.88-8.32s90.62-247.34 20.69-391.69",
    style: {
      fill: "url(#r)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6741.46 6314.46c-17.17-21.34-34.1-42.91-50.81-64.71-53.57-44.77-116.43-78.17-185.32-96.96 9.51 164.46 50.33 321.49 118.06 472.49 3.47 7.65 10.44 14.61 17.17 19.95 12.75 10.2 19.01 23.66 13.45 38.27-5.33 13.92-15.77 20.64-31.09 21.57-28.75 1.4-51.02-11.36-70.97-29.69-9.51-8.81-17.39-19.25-26.9-28.06-16.94-15.54-35.5-15.31-51.97.23-8.35 7.65-15.76 16.47-23.66 24.35-44.76 45-104.6 45.23-149.6.7-8.12-7.89-15.09-16.93-23.43-24.82-17.16-16.24-36.19-16-53.12.23-10.9 10.44-20.88 22.04-32.01 32.24-17.86 16.01-38.97 24.59-63.32 24.59-28.53 0-42.45-22.03-31.32-48.25 22.04-52.65 45.24-104.84 64.49-158.65 31.08-87.68 53.11-178.38 60.76-271.39 1.86-23.43 3.25-46.62 4.42-70.05-79.8 24.59-151.01 68.66-208.07 126.88-16.7 21.11-33.17 42.45-48.71 64.25-53.58 76.31-81.65 161.21-87.45 254.69-7.65 128.96 28.31 243.09 109.49 342.36 78.17 95.33 178.84 153.55 301.3 173.97 254.93 42.68 507.75-134.07 553.68-397.57 26.45-150.08-9.98-286.47-105.07-406.62",
    style: {
      fill: "url(#t)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6530.38 6573.32c-3.48-10.2-6.26-19.02-9.28-27.83-32.24-90.23-55.44-182.78-69.13-277.65-6.03-42.68-9.97-85.59-11.82-128.5-22.04-3.02-44.54-4.64-67.51-4.64-26.67 0-53.11 2.09-78.62 6.26-4.64 137.32-32.94 270.23-78.64 399.66-4.18 12.52-8.58 24.82-14.61 41.75 36.42-14.38 68.42-16.24 97.88 2.09 15.78 9.74 29 24.12 42.22 37.34 25.28 25.28 44.07 25.75 67.96-1.16 22.27-25.28 46.39-47.09 82.11-48.94 12.3-.46 24.59.93 39.44 1.62",
    style: {
      fill: "url(#v)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6363.13 5867.46c-62.08 0-124.16.39-186.23-.28-14.8-.15-20.58 4.28-19.1 19.36 1.15 11.76 1.43 23.87-.03 35.57-2.17 17.49 5.81 20.77 21.24 20.41 37.22-.87 74.48-.27 111.73-.28 86.37-.03 172.74-.44 259.1.26 15.78.13 21.12-4.6 19.68-20.08-1.19-12.85-1.04-25.95-.03-38.83 1.04-13.31-4.57-16.32-16.89-16.22-63.16.5-126.32.23-189.47.23z",
    style: {
      fill: "url(#x)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "matrix(.1333333 0 0 -.1333333 0 1333.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6159.13 6007.18v71.14h408.88v-71.14z",
    style: {
      fill: "url(#z)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZinizIconEps);
export default __webpack_public_path__ + "static/media/Ziniz-Icon-EPS.dba6706447d5c6b5b63f4f3325a16b40.svg";
export { ForwardRef as ReactComponent };